const averageStartingPosition = (guests) => {
  if (!guests.length) return 0;

  const totalStartingPosition = guests.reduce(
    (acc, guest) => {
      const position = guest.startedPosition || guest.startedPostion;
      if (position) {
        return (acc = acc + position);
      } else {
        return acc
      }
      },
    0
  );

  return totalStartingPosition / guests.length;
};

export const averageWaitTimeForQ =  (qDayData) => {
  const guests = Object.values(qDayData.guests || {});
  const result = Math.ceil(
    qDayData.averageWaitTimePerPosition * averageStartingPosition(guests)
  );
  return result;
};

export const countGuestStatuses = (dailyStats, todayOnly = false) => {
  //todayOnly can be true fot today or a date string for certain date, false if not provided (will iterate all data)
  const today = new Date().toLocaleDateString('en-CA');
  const data =
    todayOnly === true
      ? { daily_stats: dailyStats[today] }
      : todayOnly
      ? { daily_stats: dailyStats[todayOnly] }
      : dailyStats;
  return Object.values(data).reduce(
    (acc, dayData) => {
      if (dayData?.guests) {
        Object.values(dayData.guests).forEach((guest) => {
          if (guest) {
            if (guest.status === 'served') acc.guestsServed++;
            else if (guest.status === 'canceled') acc.canceledGuests++;
            else if (
              guest.status === 'waiting' ||
              guest.status === 'waiting-notified'
            )
              acc.waitingGuests++;
          }
        });
      }
      return acc;
    },
    { guestsServed: 0, canceledGuests: 0, waitingGuests: 0 }
  );
};

